/**
 * Copyright 2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import {
  useGetCloudResourceReportsQuery,
  CloudResourceReportsSortInput,
  CloudResourceReportsFilterInput,
} from "~/generated/graphql";

type Props = {
  page: string;
  limit: string;
  sort?: CloudResourceReportsSortInput;
  filter?: CloudResourceReportsFilterInput;
};

export function useGetCloudResourceReports({
  page,
  limit,
  sort,
  filter,
}: Props) {
  const {
    data: cloudResourceReportsData,
    loading,
    error,
  } = useGetCloudResourceReportsQuery({
    variables: {
      page: Number(page),
      limit: Number(limit),
      sort,
      filter,
    },
  });

  const data = cloudResourceReportsData?.cloudResourceReports?.result || [];
  const count =
    cloudResourceReportsData?.cloudResourceReports?.pageInfo?.count || 0;

  return { data, loading, error, count } as const;
}
